<template>
    <v-card class="login-form">
      <v-card-title>Вход</v-card-title>
      <v-card-subtitle>subtitle</v-card-subtitle>
      <v-card-text>
        <v-text-field label="Логин/Адрес электронной почты"/>
        <v-text-field label="Пароль"
                      :append-icon="passwordStyle ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="passwordStyle ? 'password' : 'text'"
                      name="input-10-1"
                      hint="At least 8 characters"
                      counter
                      @click:append="passwordStyle = !passwordStyle"/>
      </v-card-text>
      <v-card-actions>
      <v-row align="center"
                      justify="end">
        <v-btn text x-small @click="$router.push({ name: 'Register' })">Регистрация</v-btn>
        <v-btn text x-small>Вспомнить пароль</v-btn>
        <v-btn>Войти</v-btn>
        <v-btn>Очитстить</v-btn>
      </v-row>
      </v-card-actions>
    </v-card>
</template>

<script>
export default {
  name: 'RegisterView',
  data: () => ({
    passwordStyle: true,
  }),
};
</script>

<style scoped lang="sass">
@import "src/styles/base.sass"
.login-form
  width: $auth-window-width

</style>
